"use strict";
var DataStorage_1 = require("./classes/DataStorage");
var dataStorage = new DataStorage_1.DataStorage();
dataStorage.init();
module.exports = {
    DataStorage: dataStorage
};
